// Post-lock redirect. The inactivity hook (`useInactivityLock`) sets
// `ui.lockedOverlay` and clears the session; this component picks
// the correct re-auth surface on its next render.
//
// Routing policy: always /master. The inactivity lock zeroizes the
// master-derived key bundle and the current vault's keys together
// (single lock model) — the only path back is the master-password
// prompt, regardless of which vault the user was in.
//
// `returnTo` is preserved so the master-unlock can land the user
// back where they were after a successful unlock.

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUi } from "../../stores/ui";

export function LockedOverlay() {
  const overlay = useUi((s) => s.lockedOverlay);
  const hide = useUi((s) => s.hideLockedOverlay);
  const navigate = useNavigate();

  useEffect(() => {
    if (!overlay) return;
    hide();
    navigate(`/master?returnTo=${encodeURIComponent(overlay.returnTo)}`);
  }, [overlay, hide, navigate]);

  return null;
}
